
// ✅ Helper to cleanly convert to boolean or null
const parseBooleanValue = (value) => {
    if (value === "Yes") return true;
    if (value === "No") return false;
    return null;
  };
  
  export const corporateStructureApiFactory = (requestId, entityId, apiData = {}) => {
    return {
      requestId: requestId,
      entityId: entityId,
      certifiedStructureChart: parseBooleanValue(apiData.certifiedStructureChart),
      concernsRegardingStructure: parseBooleanValue(apiData.outstandingConcern),
      concernsDetails: apiData.concernDetails || null,
      mlnoNotified: false, // still hardcoded
      uboIdentified: parseBooleanValue(apiData.isUboIdentified),
      isUbo25Identified: parseBooleanValue(apiData.isUbo25Identified),
      uboType: null,
      uboState: apiData.ubos ? JSON.stringify(apiData.ubos) : JSON.stringify([{ id: 1, type: '', data: {} }]),
      reasonForNotIdentifying: apiData.whyUboNotIdentified || null,
      managedByOne: parseBooleanValue(apiData.managedByOne),
      filedThreeYearsAccounts: parseBooleanValue(apiData.threeYearUKAccount),
      knownUKCompany: parseBooleanValue(apiData.wellKnownUKCompany),
      // Omit the key entirely when the caller has no status to state. Sending
      // `status: null` looked harmless but the backend's
      // `data.get('status', 'Not Validated')` default only fires on a MISSING key —
      // a present null went straight into the column and wiped the sign-off.
      ...(apiData.status ? { status: apiData.status } : {}),
    };
  };
  
